module.exports = __webpack_public_path__ + "static/media/_democratic-republic-of-congo.01aaecd6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_democratic-republic-of-congo.svg
// module id = 2315
// module chunks = 7